module.exports = __webpack_public_path__ + "img/antes_despues_310.ccac46b5.png";